module.exports = __webpack_public_path__ + "h5-static/img/other.cd43a89f.png";